import React from "react";
import { Link } from "react-router-dom";
import "../MailchimpAlternative/MailchimpAlternative.css";

const alternatives = [
  ["Mailchimp Alternative", "/mailchimp-alternative", "For teams comparing a focused email marketing workflow with a broader marketing platform."],
  ["Brevo Alternative", "/brevo-alternative", "For teams evaluating email-first campaign work against a broader CRM and multi-channel platform."],
  ["Constant Contact Alternative", "/constant-contact-alternative", "For small businesses comparing practical campaign creation, templates, automation, and reporting."],
  ["MailerLite Alternative", "/mailerlite-alternative", "For newsletter teams weighing focused email campaigns against email plus website and landing page tools."],
  ["Klaviyo Alternative", "/klaviyo-alternative", "For teams that want focused email marketing without a larger ecommerce data platform workflow."],
];

export default function Alternatives() {
  return (
    <main className="mailchimp-page">
      <section className="mailchimp-hero alternatives-hero">
        <div className="mailchimp-hero-copy">
          <span className="mailchimp-eyebrow">Alternatives</span>
          <h1>Email Marketing Platform Alternatives</h1>
          <p>
            Compare Mailsnappy with other email marketing and customer communication platforms. These pages focus on fit, workflow, and use cases rather than unsupported claims about competitors.
          </p>
          <div className="mailchimp-actions">
            <Link to="/email-marketing-software">Explore Mailsnappy software</Link>
            <Link className="secondary" to="/pricing">View pricing</Link>
          </div>
        </div>
      </section>

      <section className="mailchimp-proof alternatives-grid">
        {alternatives.map(([title, href, text]) => (
          <article key={href}>
            <h2><Link to={href}>{title}</Link></h2>
            <p>{text}</p>
          </article>
        ))}
      </section>
    </main>
  );
}
